export default function getURLSearchParams(keys: string[]) {
	const url = new URL(window.location.href);
	return keys.reduce(
		(acc, key) => {
			const values = url.searchParams.getAll(key).flatMap((val) =>
				val
					.split(",")
					.map((s) => s.trim())
					.filter((s) => s !== ""),
			);
			if (values.length > 0) {
				acc[key] = values;
			}
			return acc;
		},
		{} as Record<string, string[]>,
	);
}
